import React, { useEffect } from "react";
import "./index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import { siteConfig } from "./siteConfig";
import { QuoteModalProvider } from "./context/QuoteModalContext";
import QuoteModal from "./components/QuoteModal";

import Header from "./components/Header";
import Footer from "./components/Footer";
import CTASection from "./components/CTASection";
import ServiceAreasStrip from "./components/ServiceAreasStrip";
import ProcessSection from "./components/ProcessSection";
import HomeReviewsSection from "./components/HomeReviewsSection";
import ChatWidgetLoader from "./components/ChatWidgetLoader";
import SmoothScroll from "./components/SmoothScroll";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import ServiceAreasPage from "./pages/ServiceAreasPage";
import ServiceAreaDetailPage from "./pages/ServiceAreaDetailPage";
import GalleryPage from "./pages/GalleryPage";
import ReviewsPage from "./pages/ReviewsPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ReviewSurveyPage from "./pages/ReviewSurveyPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

const CSSVars = () => {
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--color-primary", siteConfig.colors.primary);
    root.style.setProperty("--color-primary-dark", siteConfig.colors.primaryDark);
    root.style.setProperty("--color-dark", siteConfig.colors.dark);
    root.style.setProperty("--color-light", siteConfig.colors.light);
    root.style.setProperty("--color-accent", siteConfig.colors.accent);
    document.title = `${siteConfig.businessName} | ${siteConfig.city}, ${siteConfig.state}`;
    if (siteConfig.favicon) {
      const link = document.querySelector("link[rel='icon']") || document.createElement("link");
      link.rel = "icon";
      link.href = siteConfig.favicon;
      if (!link.parentNode) document.head.appendChild(link);
    }
  }, []);
  return null;
};

const GlobalSections = () => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  // On a /service-areas/:areaSlug page, center the strip's map on that city
  const areaMatch = pathname.match(/^\/service-areas\/([^/]+)/);
  const currentArea = areaMatch
    ? siteConfig.serviceAreas.find(
        (a) => a.toLowerCase().replace(/\s+/g, "-") === areaMatch[1]
      )
    : null;

  return (
    <>
      {!isHome && <HomeReviewsSection />}
      {!isHome && <ProcessSection />}
      {!isHome && <ServiceAreasStrip area={currentArea} />}
      <CTASection />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <QuoteModalProvider>
        <CSSVars />
        <SmoothScroll />
        <ScrollToTop />
        <ChatWidgetLoader />
        <Header />
        <QuoteModal />
        <main>
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:slug" element={<ServiceDetailPage />} />
          <Route path="/service-areas" element={<ServiceAreasPage />} />
          <Route path="/service-areas/:areaSlug" element={<ServiceAreaDetailPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/review" element={<ReviewSurveyPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
        </main>
        <GlobalSections />
        <Footer />
      </QuoteModalProvider>
    </BrowserRouter>
  );
}

export default App;
